var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.$serial.baud,"items":_vm.rates,"dense":"","hide-details":""},on:{"input":function($event){return _vm.$serial.setBaud($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }